function hideVirtualKeyboard() {
    const documentActiveElement = document.activeElement || null;
    if (documentActiveElement &&
        documentActiveElement.blur &&
        typeof documentActiveElement.blur === 'function') {
        documentActiveElement.blur();
    }
}
export { hideVirtualKeyboard };
